import { render, staticRenderFns } from "./EventTicketStatusNotAvailableWarning.vue?vue&type=template&id=2b4b8a5e&"
import script from "./EventTicketStatusNotAvailableWarning.vue?vue&type=script&lang=js&"
export * from "./EventTicketStatusNotAvailableWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports